import { VacancyType } from "@/types/vacancy/VacancyType";

// Helper function to combine feed client content
export const getCombinedFeedContent = (vacancy: VacancyType): string => {
  const parts: string[] = [];

  if (vacancy.teaser) parts.push(vacancy.teaser);
  if (vacancy.description) parts.push(vacancy.description);
  if (vacancy.jobOffer) parts.push(vacancy.jobOffer);
  if (vacancy.requirements) parts.push(vacancy.requirements);
  if (vacancy.companyDescription) parts.push(vacancy.companyDescription);

  return parts.join("<br/>");
};
